const YELLOW = "rgb(204, 179, 61)";
const PURPLE = "rgb(92, 0, 212)";
const RED = "rgb(216, 2, 69)";
const GREEN = "rgb(0, 96, 61)";
const GREY = "rgb(39, 34, 41)";

export {
  YELLOW,
  PURPLE,
  RED,
  GREEN,
  GREY
}



// WEBPACK FOOTER //
// ./src/Components/Animation/Shapes/Colors.js